import _asyncToGenerator from "/Users/liuli/Documents/hu/riscern-pc-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/search/noresultsfound.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-747f6f86"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "View Records", -1);
});

var _hoisted_3 = {
  class: "result-list"
};
var _hoisted_4 = {
  class: "num"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode("The ");

var _hoisted_6 = {
  class: "high-text"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" most recently viewed companies.");

var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "left-info"
};
var _hoisted_10 = {
  class: "text high-text--underline"
};
var _hoisted_11 = {
  class: "text high-text--underline"
};
var _hoisted_12 = {
  class: "text"
};
var _hoisted_13 = {
  class: "light-text"
};

var _hoisted_14 = /*#__PURE__*/_createTextVNode("Registration Number: ");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("Credit Social Code: ");

var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "icon"
  }, [/*#__PURE__*/_createElementVNode("i")], -1);
});

var _hoisted_17 = {
  key: 1,
  class: "empty"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1);
});

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "empty-title"
  }, "No results found", -1);
});

var _hoisted_20 = [_hoisted_18, _hoisted_19];
import { apiVipAccessList, apiTempAccessList } from '@/api/information';
import { apiGetUser } from '@/api/login';
import { ref, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { DATA_TYPE } from '@/utils/constData';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var dataList = ref([]);
    var apiLoading = ref(true);
    var searchData = ref();
    onBeforeMount(function () {
      getData();
    });

    function getData() {
      return _getData.apply(this, arguments);
    } // 去详细信息


    function _getData() {
      _getData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result, api;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiLoading.value = true;
                _context.next = 3;
                return apiGetUser();

              case 3:
                result = _context.sent;
                api = apiVipAccessList;

                if (result.vipType === DATA_TYPE.NORMAL) {
                  api = apiTempAccessList;
                }

                api().then(function (_ref2) {
                  var data = _ref2.data;
                  dataList.value = data || [];
                }).finally(function () {
                  apiLoading.value = false;
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getData.apply(this, arguments);
    }

    function onHrefCompanyInfo(_ref) {
      var keyNo = _ref.keyNo;
      router.push({
        name: 'CompanyInfo',
        query: {
          key: keyNo
        }
      });
    }

    return function (_ctx, _cache) {
      var _directive_copy = _resolveDirective("copy");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [dataList.value.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(dataList.value.length), 1), _hoisted_7]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, function (item) {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: item.id,
          onClick: function onClick($event) {
            return onHrefCompanyInfo(item);
          }
        }, [_createElementVNode("div", _hoisted_9, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [_createTextVNode(_toDisplayString(item.entityName), 1)])), [[_directive_copy, item.entityName]]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [_createTextVNode(_toDisplayString(item.enName), 1)])), [[_directive_copy, item.enName]]), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, [item.countryCode !== 86 ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_hoisted_14], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_hoisted_15], 64))]), _withDirectives((_openBlock(), _createElementBlock("span", null, [_createTextVNode(_toDisplayString(item.entityNo), 1)])), [[_directive_copy, item.entityNo]])])]), item.status ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['status', item.status])
        }, [_hoisted_16, _createElementVNode("div", null, _toDisplayString(item.status), 1)], 2)) : _createCommentVNode("", true)], 8, _hoisted_8);
      }), 128))], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))])), [[_directive_loading, apiLoading.value]])]);
    };
  }
});